export const formatError = (err: any): string => {
  if (err && err.data && err.data.message) {
    return `${err.data.message}\n ${JSON.stringify(err.data.extra, null, 2)}`;
  }
  return '';
};
